// Hotwire Native components. Needs `@hotwired/hotwire-native-bridge` in the
// host's package.json (fire/docs/HOTWIRE.md).
import AlertController from './bridge/alert_controller';
import AppleController from './bridge/apple_controller';
import ButtonController from './bridge/button_controller';
import HapticController from './bridge/haptic_controller';
import LocationController from './bridge/location_controller';
import MenuController from './bridge/menu_controller';
import NFCScannerController from './bridge/nfc_scanner_controller';
import OAuthController from './bridge/oauth_controller';
import PushNativeController from './bridge/push_controller';
import QRScannerController from './bridge/qr_scanner_controller';
import ShareController from './bridge/share_controller';
import WidgetController from './bridge/widget_controller';

export function registerFireBridge(application) {
  application.register('bridge--alert', AlertController);
  application.register('bridge--apple', AppleController);
  application.register('bridge--button', ButtonController);
  application.register('bridge--haptic', HapticController);
  application.register('bridge--location', LocationController);
  application.register('bridge--menu', MenuController);
  application.register('bridge--nfcscanner', NFCScannerController);
  application.register('bridge--oauth', OAuthController);
  application.register('bridge--push', PushNativeController);
  application.register('bridge--qrscanner', QRScannerController);
  application.register('bridge--share', ShareController);
  application.register('bridge--widget', WidgetController);
}
